function calculateBidVsLowestPercentage(bid, shownBids) {
  if (!shownBids || shownBids.length === 0) return null;
  const lowestBid = shownBids[0];
  if (!lowestBid || !lowestBid.amount) return null;
  return (lowestBid.amount - bid.amount) / lowestBid.amount;
}

/**
 * Maps bid comparison vs lowest bid to BaseTag tone (same rules as former BaseTag colors).
 */
export function getBiBidListTagTone(bid, index, shownBids) {
  const percentage = calculateBidVsLowestPercentage(bid, shownBids);
  if (percentage >= 0 || index === 0) {
    return 'success';
  }
  return 'destructive';
}
